import script from "./Permission.js?vue&type=script&lang=js"
export * from "./Permission.js?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__